import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import vueAxios from 'vue-axios'
import VueMeta from 'vue-meta'

createApp(App).use(router).mount('#app')
App.use(VueMeta)
